// import mockedVideos from "../../mock/videos";
import request from "@/utils/request"

/**
 *
 * @param {Object} filters - object containing filters fields
 * (params) to fetch videos with
 * @returns {Object} fetched videos response object
 */
export function getVideos(filters) {
  const params = getRequestParams(filters)
  return request({
    url: "/api/videos",
    method: "get",
    params
  })
}

/**
 *
 * @param {Object} filters - object containing filters fields
 * (params) to fetch videos with
 * @returns {Object} fetched videos response object
 */
export function getAllVideos() {
  const params = getRequestParams()
  return request({
    url: "/api/videos/get/all",
    method: "get",
    params
  })
}

/**
 *
 * @param {Object} filters - object containing filters fields
 * (params) to fetch videos with
 * @returns {Object} fetched videos response object
 */
export function getSponsoredVideos(filters) {
  const params = getRequestParams(filters)
  return request({
    url: "/api/videos/sponsored/all",
    method: "get",
    params
  })
}

/**
 *
 * @param {Object} filters - object containing filters fields
 * (params) to fetch videos with
 * @returns {Object} fetched videos response object
 */
export function getSponsoredVideosOfAnnonceur(filters, id) {
  const params = getRequestParams(filters)
  return request({
    url: "/api/videos/sponsored/" + id + "/get",
    method: "get",
    params
  })
}

/**
 * fetches a video with given id
 * @param {Number} id - video id to fetch
 * @returns {Object} - fetched video reponse object
 */
export function fetchVideo(id) {
  if (!id && typeof id !== "number") {
    throw new Error("No video id was given.")
  }
  return request({
    url: "/api/videos/" + id,
    method: "get"
  })
}

/**
 * Updates a video with given id
 * @param {Number} id - video id to update
 * @param {Object} params -
 * @param {Object} data -
 * @returns {Object} - updated video reponse object
 */
export function updateVideo(id, params = {}, data) {
  if (!id && typeof id !== "number") {
    throw new Error("No video id was given.")
  }
  return request({
    url: "/api/videos/" + id,
    method: "post",
    data,
    params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 * Adds video to videos list
 * @param {Object} params -
 * @param {Object} data -
 * @returns {Object} - Added video reponse object
 */
export function addNewVideo(params, data) {
  return request({
    url: "/api/videos",
    method: "post",
    data,
    params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 * Adds video to videos list
 * @param {Object} params -
 * @param {Object} data -
 * @returns {Object} - Added video reponse object
 */
export function addSponsoredVideo(params, data) {
  return request({
    url: "/api/video/sponsored/add",
    method: "post",
    data,
    params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 * Updates a video with given id
 * @param {Number} id - video id to update
 * @param {Object} params -
 * @param {Object} data -
 * @returns {Object} - updated video reponse object
 */
export function updateSponsoredVideo(id, params = {}, data) {
  if (!id && typeof id !== "number") {
    throw new Error("No video id was given.")
  }
  return request({
    url: "/api/video/sponsored/edit/" + id,
    method: "post",
    data,
    params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

/**
 * Deletes a video with given id
 * @param {Number} id - video id to delete
 * @returns {Object} - deleted video reponse object
 */
export function deleteVideo(id) {
  if (!id && typeof +id !== "number") {
    throw new Error("No video id was given.")
  }
  return request({
    url: "/api/videos/" + id,
    method: "delete"
  })
}

/**
 * Fetches video status
 */
export function fetchVideosStatuses() {
  return request({
    url: "/api/videos/statuses",
    method: "get"
  })
}

/**
 * Constructs videos fetch params
 * @param {Objecy} filters - filters object
 * @returns {Object} params obj to pass to axios videos request
 */
function getRequestParams({
  type_supports = [],
  brands = [],
  themes = [],
  page = 1,
  keyword = "",
  // in case we want to pass any other filters
  // e.g: trending: 1 or 0
  ...others
} = {}) {
  return {
    supports: type_supports.map(({ id }) => id),
    brands: brands.map(({ id }) => id),
    themes: themes.map(({ id }) => id),
    page,
    keyword,
    ...others
  }
}

/**
 * Download the list of videos
 * @returns {Object} - fetched video reponse object
 */
export function exportVideosList() {
  return request({
    url: "/api/videos/export",
    method: "get",
    responseType: "blob"
  })
}
